<template lang="pug">
.znoContainer
  .znoMainContainer
    section.hero.is-medium
      .hero-body
        .containers(:class="{'mobile': isMobileDevice, 'desktop': !isMobileDevice}")
          .descriptionContainer
            h2.subtitle 宝くじをもっと楽しく
            p.heroDescription IXA は 「数字選択式全国自治宝くじ」の数字選択に於いて、普段選択しないような数値を楽しく導き出す完全無料のサービスです。画面右上のメニューから遊びたいサービスをお選びください。
              
            p.attention
              | ※ IXAのご利用は
              router-link(to="/terms") 利用規約、
              | IXAによる COOKIE、LocalStorage 使用の同意の上でお願いします。
          .kuji
            img(src="../assets/kuji.svg" width="400")
    .serviceList.columns
      .serviceItem.column
        h3 選択数字ジェネレーター
        p: img(src="../assets/random.png")
        p 生成ボタンを押したその瞬間に <a href="https://github.com/d3/d3/blob/master/API.md#random-numbers-d3-random">D3.js</a> の ランダム生成を使った選択数値を出力します。祈りを込めて押しちゃいましょう
        p 生成された数字を更にクリック（タップ）することでハイライト表示になります。大量生成後の選択に便利です。
      .serviceItem.column
        h3 選択数字履歴
        p: img(src="../assets/log.png")
        p 生成後、購入予定となる選択数字は選択した数に応じた金額とともに保存することが出来ます。<br><span>（抽選について：ナンバーズは月曜日から金曜日、ロト7は金曜日、ロト6は月曜日と木曜日、それぞれ19時ごろ）</span>
      .serviceItem.column
        h3 当選番号速報 
        p: img(src="../assets/result.png")
        p 現時点ではまだ実装していませんが、ゆくゆくは当選結果番号をそこそこ速い段階で知ることが 仕組みを用意しようと思っています。うひょー！
      
  .ecoContainer
    h3 通信は最小限に、ログインいらず
    p IXA は面倒な登録処理・ログインをせずに利用できます。データの保存もサーバーには行いませんのモバイル環境でも安心して使うことができます。
    p 運用のために、Google Adsens などの広告を入れることがありますが怪しい広告媒体は使用しないのでご安心ください

  .backStoryContainer
    h3 IXA 誕生のきっかけ
    p IXA は、最初はクジ運の悪いボクのために開発しました。クジ運なのでどこまで行っても運要素なのですが、なんとかしたかったボクは数字自体を「自分で考えなければ当たるのでは？」という他人行儀・運否天賦すぎる考えがきっかけです。戦略なんてありません。皆無です！
    p このサービスの設計時、どうせならログを残したり、クジの生み出し方に工夫をしてみたかったりとアイディアはどんどん広がっていきました。そんな中、きっと遊んでくれる方もいるはず！と思い、ある意味ノリだけで開発を続けております。当たりたいですよね。高額当選。当てましょう！IXA で！

</template>

<script>
const Random = require('random')
const D3Random = require('d3-random')
const seed = require('seedrandom')
const UAParser = require('ua-parser-js')
export default {
  name: 'home',
  data(){
    return {
      isActive: false,
      isMobileDevice: null
    }
  },
  computed: {
  },
  methods: {
  },
  mounted(){
    this.$EventBus.$emit('naviClose')
  },
  created(){
    this.isMobileDevice = UAParser().device.type === 'mobile'? true : false
  }
}
</script>

<style scoped lang="stylus">
.znoContainer
  margin-top: 52px!important
  padding-bottom: 60px
  width: 100%
  .znoMainContainer
    width: 96%
    margin: 60px auto 60px auto 
    .ixaTitle
      text-align: center
      font-weight: bolder
      margin-bottom: 20px
  section.hero.is-medium
    .hero-body
      .containers
        display: flex
        justify-content: space-between!important
        .descriptionContainer
          width: 60%
          padding-bottom: 50px!important
          h2.subtitle
            font-size: 1.8rem!important
            font-weight: bolder
          .hero_navLink
            font-size: 0.8rem
          .button
            margin-top: 16px
          .attention
            margin-top: 16px
            font-size: 0.7rem
        &.mobile
          display: block!important
          .descriptionContainer
            width: 100% 
  .serviceList.columns
    width:90%
    margin: 0 auto
    .serviceItem.column
      h3
        font-size: 1.2rem
        font-weight: bolder
      p
        margin-top: 16px
        font-size: 0.9rem
        line-height: 2em
        span
          font-size: 0.7rem
  .ecoContainer, .backStoryContainer
    width: 100%
    padding: 60px 40px
    background-color: #3273dc
    h3
      font-size: 1.8rem
      font-weight: bolder
      color: #FFF
      line-height: 2em
    p
      font-size: 1rem
      line-height: 2em
      color: #FFF
  .backStoryContainer
    background-color: #FFF!important
    h3, p
      color: #555
    p
      margin-top: 20px
</style>
